import { render } from "./BarcodeSearchButton.vue?vue&type=template&id=2c84fb6a&scoped=true"
import script from "./BarcodeSearchButton.vue?vue&type=script&lang=ts"
export * from "./BarcodeSearchButton.vue?vue&type=script&lang=ts"

import "./BarcodeSearchButton.vue?vue&type=style&index=0&id=2c84fb6a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2c84fb6a"

export default script